import React from 'react';
import ReactDOM from 'react-dom';
import { X, FileText } from 'lucide-react';

interface ConvoSummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  summary: string;
  leadName?: string;
  companyName?: string;
  channel?: 'LinkedIn' | 'WhatsApp' | 'Email' | 'Call';
}

const ConvoSummaryModal: React.FC<ConvoSummaryModalProps> = ({
  isOpen,
  onClose,
  summary,
  leadName = 'Lead',
  companyName,
  channel = 'LinkedIn',
}) => {
  if (!isOpen) return null;

  const subtitle = `Summary of the conversation with ${leadName} on ${channel}`;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col shadow-2xl shadow-black/20 animate-fadeIn">
        <div className="flex items-center justify-between px-6 py-5 border-b border-[#05E0D1]/20 bg-gradient-to-r from-[#05E0D1]/5 to-[#1875FF]/5">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-[#05E0D1] to-[#1875FF] rounded-xl flex items-center justify-center shadow-lg">
              <FileText className="text-white" size={18} />
            </div>
            <div>
              <h3 className="text-lg font-extrabold text-gray-900 font-display">Conversation Summary</h3>
              <p className="text-xs text-gray-500 font-medium">{subtitle}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-white rounded-lg"
          >
            <X size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto custom-scrollbar bg-gray-50/50 p-6">
          {!summary || summary.trim() === '' ? (
            <div className="text-center py-16">
              <FileText size={40} className="mx-auto text-gray-300 mb-3" />
              <p className="text-gray-400 text-sm font-medium">No summary available</p>
            </div>
          ) : (
            <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
              <div className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">
                {summary}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConvoSummaryModal;
